__turbopack_context__.v({
  "card": "styles-module-scss-module__ipG6HW__card",
  "card__bullet": "styles-module-scss-module__ipG6HW__card__bullet",
  "card__chart": "styles-module-scss-module__ipG6HW__card__chart",
  "card__content": "styles-module-scss-module__ipG6HW__card__content",
  "card__decoration": "styles-module-scss-module__ipG6HW__card__decoration",
  "card__disclaimer": "styles-module-scss-module__ipG6HW__card__disclaimer",
  "card__fade": "styles-module-scss-module__ipG6HW__card__fade",
  "card__item": "styles-module-scss-module__ipG6HW__card__item",
  "card__itemDescription": "styles-module-scss-module__ipG6HW__card__itemDescription",
  "card__itemTitle": "styles-module-scss-module__ipG6HW__card__itemTitle",
  "card__items": "styles-module-scss-module__ipG6HW__card__items",
  "card__label": "styles-module-scss-module__ipG6HW__card__label",
  "card__labelCaption": "styles-module-scss-module__ipG6HW__card__labelCaption",
  "card__labelValue": "styles-module-scss-module__ipG6HW__card__labelValue",
  "card__labelWith": "styles-module-scss-module__ipG6HW__card__labelWith",
  "card__labelWithout": "styles-module-scss-module__ipG6HW__card__labelWithout",
  "card__mobileLogo": "styles-module-scss-module__ipG6HW__card__mobileLogo",
  "card__modQualified": "styles-module-scss-module__ipG6HW__card__modQualified",
  "card__subtitle": "styles-module-scss-module__ipG6HW__card__subtitle",
  "card__title": "styles-module-scss-module__ipG6HW__card__title",
});
